export default "__VITE_ASSET__BD98MiKT__"